module.exports = __webpack_public_path__ + "media/img/Landing_Page/Scholarships2u-Search-Scholarship-375e3819dc39ac7e9b81502679fabd78.svg";